import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { KewnetStatus } from 'app/constants';

export const orderEndpoints = (builder: EndpointBuilder<any, any, any>) => ({
  reactivateOrder: builder.mutation<unknown, { orderId: number }>({
    query: ({ orderId }) => ({
      url: `/order/${orderId}/`,
      method: 'PUT',
      body: { status: KewnetStatus.inProgress },
    }),
    invalidatesTags: () => [
      { type: 'Tour', id: 'LIST' },
      { type: 'PartOrder', id: 'LIST' },
      { type: 'Delivery', id: 'LIST' },
    ],
  }),
});
